<div
  *ngIf="spinner"
  class="position-fixed top-0 vw-100 vh-100 d-flex align-items-center justify-content-center"
  style="background-color: rgba(0, 0, 0, 0.5); z-index: 1000"
>
  <div class="spinner-border" role="status"></div>
</div>
<main class="main">
  <form class="content" [formGroup]="form">
    <section class="content--item">
      <h2 class="content--title">
        {{ 'manageYourData' | i18next }}
      </h2>
      <div *ngIf="user.groupType === collective.EXTERNVO">
        <p>
          <em>"{{ 'manageDataRelative' | i18next }}"</em>
        </p>
      </div>
      <div *ngIf="user.groupType !== collective.EXTERNVO">
        <p>
          <em>"{{ 'infoData' | i18next }}"</em>
        </p>
        <p>
          <em>"{{ 'infoData2' | i18next }}"</em>
        </p>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'personalEmail' | i18next }}</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'phone' | i18next }}</mat-label>
          <input
            *ngIf="user.groupType === collective.EXTERNVO"
            matInput
            formControlName="phone"
            minglength="9"
            maxlength="9"
          />
          <input
            *ngIf="user.groupType !== collective.EXTERNVO"
            matInput
            formControlName="phone"
            minglength="9"
          />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'province' | i18next }}</mat-label>
          <mat-select formControlName="state">
            <mat-option *ngFor="let option of states" [value]="option.code">{{
              option.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'city' | i18next }}</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'roadType' | i18next }}</mat-label>
          <input matInput formControlName="roadType" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'streetName' | i18next }}</mat-label>
          <input matInput formControlName="street" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'number' | i18next }}</mat-label>
          <input matInput formControlName="number" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'roadComplement' | i18next }}</mat-label>
          <input matInput formControlName="complement" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'postalCode' | i18next }}</mat-label>
          <input matInput formControlName="postalCode" />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'country' | i18next }}</mat-label>
          <mat-select formControlName="country">
            <mat-option
              *ngFor="let option of countries"
              [value]="option.code"
              >{{ option.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="content--judgements"
        *ngIf="user.groupType === collective.EXTERNVO"
      >
        <div class="content--checkboxes">
          <div class="content--checkboxItem">
            <mat-checkbox
              formControlName="commercialCommunicationsConsent"
              (change)="onCommercialConsentChange($event)"
            >
              {{ 'commercialCommunicationsConsent' | i18next }}
            </mat-checkbox>
          </div>
          <div class="content--checkboxItem">
            <mat-checkbox formControlName="privacyPolicyAccepted">
              {{ 'accept' | i18next }}
              <a
                href="assets/documents/Política de privacidad.pdf"
                target="_blank"
                rel="noopener noreferrer"
                (click)="$event.stopPropagation()"
              >
                {{ 'privacy' | i18next }}
              </a>
              *
            </mat-checkbox>
          </div>
        </div>
      </div>
    </section>
  </form>

  <div class="main--btnContainer">
    <button
      class="main--btnContainer__btn btn confirm"
      [style]="'background-color: #2c2a29'"
      mat-button
      (click)="updateUser()"
      [disabled]="form.invalid"
      [style]="
        form.invalid ? 'background-color: #565554' : 'background-color: #2c2a29'
      "
    >
      {{ 'update' | i18next | uppercase }}
    </button>
    <button
      class="main--btnContainer__btn btnReturn"
      mat-button
      (click)="goBack()"
    >
      <mat-icon class="icon">arrow_back</mat-icon>
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</main>
